// drivers.js
import req from "./axios";
import { isMockJs } from "./axios";

export const configurationDelete = sendData =>
  req("delete", isMockJs ? "/configuration/delete" : `/configuration/${sendData.id}/`);

export const configurationDeleteList = sendData =>
  req(
    "delete",
    isMockJs ? "/configuration/multi-delete" : `/configuration/multi-delete/`,
    sendData
  );

export const configurationList = sendData =>
  req("get", isMockJs ? "/configuration/configuration" : `/configuration/`, sendData);

export const configurationItem = sendData =>
  req("get", isMockJs ? "/configuration/configurationItem" : `/configuration/${sendData.id}/`);

export const configurationCreate = sendData =>
  req("post", isMockJs ? "/configuration/configuration" : `/configuration/`, sendData);

export const configurationUpdate = sendData =>
  req(
    "put",
    isMockJs ? "/configuration/configuration" : `/configuration/${sendData.id}/`,
    sendData.data
  );

// export const aaa = (sendData) => req('get', isMockJs ? '/models/aaaaa' : `models/${sendData.name}/${sendData.id}/`, sendData);

//測試 404
// export const configurationList = (sendData) => req('get', isMockJs ? '/configuration/configuration' : `/configuration/we43434`,sendData);
